import classNames from 'classnames';
import * as React from 'react';

import css from './BooksLoading.module.scss';

const BooksLoading = () => {
  const classes = classNames(css.BooksLoading);

  return (
    <div className={classes}>
      <div className={css.BooksLoading_Icon} />
    </div>
  );
};

export default BooksLoading;
